import { ScreenWaveLoader } from '@/shared'
import loadable from '@loadable/component'

export const ToteLandingScreenLazy = loadable(
  () => import('./ToteLandingScreen'),
  {
    fallback: <ScreenWaveLoader />
  }
)
